<template>
  <div class="clearfix">
    <!-- 侧导航 -->
    <el-menu default-active="2" class="fl el-menu-vertical-demo sideNav" unique-opened :default-active="activePath" @select="handleSelect">
      <el-submenu index="1">
        <template slot="title">
          <span>交易</span>
          <img v-if="activeFlag.trade.flag" class="margin-l10" src="../../assets/images/message1.png" alt="">
        </template>
        <el-menu-item index="交易通知">
          <span>交易通知</span>
          <span v-if="activeFlag.trade.child.交易成功" class="messagePoint"></span>
        </el-menu-item>
      </el-submenu>
      <el-submenu index="2">
        <template slot="title">
          <span>提醒</span>
          <img v-if="activeFlag.warning.flag" class="margin-l10" src="../../assets/images/message1.png" alt="">
        </template>
        <el-menu-item index="直播开播">
          <span>直播开播</span>
          <span v-if="activeFlag.warning.child.直播开播" class="messagePoint"></span>
        </el-menu-item>
        <el-menu-item index="优惠券到期">
          <span>优惠券到期</span>
          <span v-if="activeFlag.warning.child.优惠券到期" class="messagePoint"></span>
        </el-menu-item>
        <el-menu-item index="理财产品到期">
          <span>理财产品到期</span>
          <span v-if="activeFlag.warning.child.理财产品到期" class="messagePoint"></span>
        </el-menu-item>
        <el-menu-item index="其它">
          <span>其它</span>
          <span v-if="activeFlag.warning.child.其它" class="messagePoint"></span>
        </el-menu-item>
      </el-submenu>
      <el-submenu index="3">
        <template slot="title">
          <span>资讯</span>
          <img v-if="activeFlag.information.flag" class="margin-l10" src="../../assets/images/message1.png" alt="">
        </template>
        <el-menu-item index="展恒早报">
          <span>展恒早报</span>
          <span v-if="activeFlag.information.child.展恒早报" class="messagePoint"></span>
        </el-menu-item>
        <el-menu-item index="展恒视角">
          <span>展恒视角</span>
          <span v-if="activeFlag.information.child.展恒视角" class="messagePoint"></span>
        </el-menu-item>
        <el-menu-item index="公募研报">
          <span>公募研报</span>
          <span v-if="activeFlag.information.child.公募研报" class="messagePoint"></span>
        </el-menu-item>
        <el-menu-item index="私募研报">
          <span>私募研报</span>
          <span v-if="activeFlag.information.child.私募研报" class="messagePoint"></span>
        </el-menu-item>
      </el-submenu>
      <el-submenu index="4" class="four">
        <template slot="title">
          <span>公告</span>
          <img v-if="activeFlag.notice.flag" class="margin-l10" src="../../assets/images/message1.png" alt="">
        </template>
        <el-menu-item index="系统公告">
          <span>系统公告</span>
          <span v-if="activeFlag.notice.child.系统公告" class="messagePoint"></span>
        </el-menu-item>
      </el-submenu>
    </el-menu>
    <div class="fl common-box margin-l6" style="width:986px;">
      <MassageCon :activePath="activePath" @emptyAll="emptyAll()"></MassageCon>
    </div>
  </div>
</template>

<script>
import MassageCon from './messageCon.vue'
export default {
  name: "messageCenter",
  components: {
    MassageCon
  },
  created () {
    this.isRead()
  },
  data () {
    return {
      activePath: '交易通知',
      activeFlag: {
        information: {
          flag: false,
          child: {
            公募研报: false,
            展恒早报: false,
            展恒视角: false,
            私募研报: false,
          }
        },
        notice: {
          flag: false,
          child: {
            系统公告: false,
          }
        },
        trade: {
          flag: false,
          child: {
            交易成功: false,
          }
        },
        warning: {
          flag: false,
          child: {
            优惠券到期: false,
            其他: false,
            理财产品到期: false,
            直播开播: false,
          }
        }
      },
    }
  },
  methods: {
    handleSelect (path, indexPath) {
      this.activePath = path
    },
    // 判断未读消息
    isRead () {
      this.$http.post(this.$apiPath.isReadMessage, {
        custno: this.$commonJs.getCookie('u_custno1'),
      }).then(res => {
        // console.log(res);
        if (res.data.code == "200") {
          this.activeFlag = res.data.data
        }
      }).catch(err => { })
    },
    emptyAll () {
      this.isRead()
    },

  }
}
</script>

<style lang="less" >
.sideNav {
  width: 148px;
  border: 1px solid @colorC8;
  .el-submenu__title {
    font-size: 16px;
    font-weight: bold;
    padding-left: 30px !important;
  }
  .el-submenu__title:hover {
    background: @wColor;
  }
  .el-submenu.is-active .el-submenu__title {
    color: @color;
  }
  .el-submenu .el-menu-item {
    color: @color6;
    min-width: 148px;
  }
  .el-submenu .el-menu-item:hover {
    background: @oColor13;
  }
  .el-menu-item.is-active {
    background: @oColor13;
  }
}
// 小红点
.messagePoint {
  position: relative;
}
.messagePoint::before {
  position: absolute;
  left: 6px;
  top: 6px;
  content: "";
  width: 4px;
  height: 4px;
  background: @rColor;
}
</style>

